<template>
  <div>
    <el-dialog
      ref="viewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="add_view_edit_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('viewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        element-loading-text="努力加载数据中，请耐心等待"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogViewForm"
          :model="dialogViewForm"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="省区">
                    <el-input
                      v-model="dialogViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="城市">
                    <el-input
                      v-model="dialogViewForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="付款单位">
                    <el-input
                      v-model="dialogViewForm.paymentUnitName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="收款单位">
                    <el-input
                      v-model="dialogViewForm.receiveUnitName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="收款银行">
                    <el-input
                      v-model="dialogViewForm.receiveBankName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="收款账号">
                    <el-input
                      v-model="dialogViewForm.receiveBankNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="收款日期">
                    <el-date-picker
                      v-model="dialogViewForm.receiveDateValue"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="凭证号">
                    <el-input
                      v-model="dialogViewForm.voucherNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="实际收款金额">
                    <el-input
                      v-model="dialogViewForm.receiveAmount"
                      disabled
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="差异金额">
                    <el-input
                      v-model="dialogViewForm.differenceAmount"
                      disabled
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              明细信息
            </h3>
            <div class="modal-row-box">
              <el-row
                :gutter="10"
                style="margin-bottom:5px;"
              >
                <el-col :span="24">
                  <el-table
                    :data="dialogViewForm.paidDetailData"
                    style="width: 100%"
                    :header-cell-style="{background:'#0076ff'}"
                    border
                    show-summary
                    :summary-method="getSummaries"
                  >
                    <el-table-column
                      type="index"
                      label="序号"
                      width="60"
                      align="center"
                    />
                    <el-table-column
                      label="项目编号"
                      prop="projectNo"
                      width="160"
                      header-align="center"
                    />
                    <el-table-column
                      label="项目名称"
                      prop="projectName"
                      show-overflow-tooltip
                      header-align="center"
                    />
                    <el-table-column
                      label="季度"
                      prop="quarter"
                      width="80"
                      align="center"
                    />
                    <el-table-column
                      label="应收金额(元)"
                      prop="totalAmount"
                      width="110"
                      align="center"
                    >
                      <template slot-scope="scope">
                        {{ formatNumberThousandSeparator(scope.row.totalAmount) }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="amount"
                      label="收款金额(元)"
                      width="110"
                      align="center"
                    >
                      <template slot-scope="scope">
                        {{ formatNumberThousandSeparator(scope.row.amount) }}
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              附件信息
            </h3>
            <div class="modal-row-box">
              <div class="demo-input-suffix">
                <show-preview :arr-file-data="picList" />
              </div>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              操作备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item>
                    <el-input
                      v-model="dialogViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="创建人">
                    <el-input
                      v-model="dialogViewForm.creator"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="创建时间">
                    <el-input
                      v-model="dialogViewForm.createTimeValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="复核人">
                    <el-input
                      v-model="dialogViewForm.checker"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="复核时间">
                    <el-input
                      v-model="dialogViewForm.checkTimeValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 图片预览
import showPreview from '@/components/showPreview'
// 数据请求
import { initReceiveVoucherApi } from '@/api/receiveVoucher'

export default {
  components: { showPreview },
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: true,

      dialogViewForm: {
        paidDetailData: []
      },
      picList: [], // 照片对象数组
      baseUrl: ''
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.loading = true
        this.baseUrl = process.env.VUE_APP_BASE_API
        this.dialogViewForm = {
          paidDetailData: []
        }
        this.picList = []
        this.initViewData()

        this.$nextTick(() => {
          this.$refs.dialogViewForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    initViewData() {
      initReceiveVoucherApi({ id: this.dataId }).then(res => {
        const { receiveVoucher, receivableReceives, fileList } = res.data

        this.dialogViewForm = receiveVoucher || {}
        this.dialogViewForm.receiveAmount = this.formatNumberThousandSeparator(this.dialogViewForm.receiveAmount)
        this.dialogViewForm.paidDetailData = receivableReceives || []

        //附件相关
        if (fileList.length > 0) {
          fileList.forEach(item => {
            this.picList.push({
              name: item.attachmentName,
              url: this.baseUrl + item.attachmentUrl,
              attachmentName: item.attachmentName,
              attachmentUrl: item.attachmentUrl
            })
          })
        }
        this.loading = false
      })
    },
    // 收款明细TABLE合计方法
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (column.property === 'amount' || column.property === 'payableAmount') {
          sums[index] = values.reduce((prev, curr) => {
            return Number((prev + curr).toFixed(2))
          }, 0)
          sums[index] = this.formatNumberThousandSeparator(sums[index])
        }
      })
      return sums
    },
    // 关闭弹框
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
  }
}
</script>
<style lang="scss"  scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 2px;
  font-size: 12px;
}
::v-deep .el-table--mini td {
  padding: 2px;
}
::v-deep .special-row .el-col {
  min-height: 20px;
}
.pic-container {
  position: relative;
  .pic-name {
    display: inline-block;
    padding-top: 7px;
    margin-bottom: 10px;
  }
  .upload-button {
    position: absolute;
    top: 0;
    right: 0px;
  }
  ::v-deep .el-upload--picture-card i {
    font-size: 14px !important;
    color: #fff !important;
  }
  ::v-deep .el-upload--picture-card {
    border: none;
    height: 0px;
    overflow: hidden;
  }
}
::v-deep .el-upload-list--picture-card {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  .el-upload-list__item {
    display: flex;
    flex: 0 0 218px;
    margin-right: 8px;
    width: 218px;
    height: 218px;
    align-items: center;
    border-radius: 0;
  }
  .el-upload-list__item-thumbnail {
    height: auto;
    align-items: center;
  }
}
::v-deep .el-table__row {
  .el-form-item__error {
    display: none;
  }
  .el-form-item--mini.el-form-item {
    margin-bottom: 0px;
  }
}
.demo-input-suffix {
  padding: 10px 0;
  .el-input {
    margin-right: 10px;
    width: 120px;
  }
  .title-sp {
    color: #1a9bff;
    margin-right: 10px;
  }
}
</style>
